import { ReactNode } from 'react';
import { AppBar, Box, Button, IconButton, Stack, Toolbar, Typography } from '@mui/material';
import { MainProfileMenu } from './MainProfileMenu';

type MainTopBarProps = {
  headerLabel?: ReactNode;
  profileLabel: string;
  accountLevel?: number;
  canEditTheme: boolean;
  onOpenExternalKeys: () => void;
  onOpenFeedback?: () => void;
  onOpenHelp?: () => void;
  onNavigateProfile: () => void;
  onNavigateBilling: () => void;
  onNavigateArchived: () => void;
  onEditTheme: () => void;
  onLogout: () => void;
};

export const MainTopBar = ({
  headerLabel,
  profileLabel,
  accountLevel,
  canEditTheme,
  onOpenExternalKeys,
  onOpenFeedback = () => undefined,
  onOpenHelp = () => undefined,
  onNavigateProfile,
  onNavigateBilling,
  onNavigateArchived,
  onEditTheme,
  onLogout,
}: MainTopBarProps) => {
  const upgradeLabel =
    accountLevel === 99 ? 'Upgrade from a trial account' : accountLevel === 0 ? 'Upgrade' : null;

  return (
    <AppBar
      position="relative"
      color="inherit"
      elevation={0}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        borderBottom: '2px solid #f1f1f1',
        px: 1,
        height: '90px',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Toolbar
        sx={{
          justifyContent: headerLabel ? 'space-between' : 'flex-end',
          minHeight: '90px !important',
          px: 0,
        }}
      >
        {headerLabel &&
          (typeof headerLabel === 'string' ? (
            <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '25px', lineHeight: 1 }}>
              {headerLabel}
            </Typography>
          ) : (
            headerLabel
          ))}
        <Stack direction="row" spacing={3.75} alignItems="center">
          {upgradeLabel ? (
            <Button
              variant="outlined"
              onClick={onNavigateBilling}
              sx={{
                minWidth: 0,
                px: 2.5,
                whiteSpace: 'nowrap',
                color: '#e1386a',
                borderColor: '#e1386a',
                backgroundColor: '#ffffff',
                borderWidth: 2,
                fontWeight: 'bold',
                '&:hover': {
                  borderColor: '#e1386a',
                  backgroundColor: '#ffffff',
                },
              }}
            >
              {upgradeLabel}
            </Button>
          ) : null}
          <Stack direction="row" spacing={2} alignItems="center">
            <IconButton sx={{ width: 30, height: 30, p: 0 }} onClick={onOpenFeedback}>
              <Box
                component="img"
                src="https://storage.googleapis.com/dotstorming-img/feedback.svg"
                sx={{ width: 27, height: 27 }}
              />
            </IconButton>
            <IconButton sx={{ width: 30, height: 30, p: 0 }} onClick={onOpenHelp}>
              <Box
                component="img"
                src="https://storage.googleapis.com/dotstorming-img/help.svg"
                sx={{ width: 27, height: 27 }}
              />
            </IconButton>
          </Stack>
          <MainProfileMenu
            profileLabel={profileLabel}
            canManageExternalKeys={Boolean((accountLevel ?? 0) > 0)}
            canEditTheme={canEditTheme}
            onNavigateProfile={onNavigateProfile}
            onNavigateBilling={onNavigateBilling}
            onNavigateArchived={onNavigateArchived}
            onOpenExternalKeys={onOpenExternalKeys}
            onEditTheme={onEditTheme}
            onLogout={onLogout}
          />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
